import { OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import find from 'lodash-es/find';
import { DateService } from '../../core/date.service';
var DateEntryComponent = /** @class */ (function () {
    function DateEntryComponent(dateService) {
        this.dateService = dateService;
        this.years = [];
    }
    DateEntryComponent.prototype.ngOnInit = function () {
        this.years = this.dateService.lastXYears(10);
        this.months = this.dateService.months;
    };
    DateEntryComponent.prototype.selectYear = function (year, event) {
        event.preventDefault();
        this.form.controls['year'].setValue(year);
        this.months = this.dateService.pastCurrentMonthsForYear(year);
        this.invalidateFutureMonth();
    };
    DateEntryComponent.prototype.invalidateFutureMonth = function () {
        var selectedMonth = this.form.controls['month'].value;
        if (selectedMonth && !find(this.months, function (month) { return month.monthNumber === selectedMonth.monthNumber; })) {
            this.form.controls['month'].setValue(null);
        }
    };
    DateEntryComponent.prototype.selectMonth = function (month, event) {
        event.preventDefault();
        this.form.controls['month'].setValue(month);
    };
    Object.defineProperty(DateEntryComponent.prototype, "selectedYear", {
        get: function () {
            return this.form.controls['year'].value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateEntryComponent.prototype, "selectedMonth", {
        get: function () {
            return this.form.controls['month'].value;
        },
        enumerable: true,
        configurable: true
    });
    return DateEntryComponent;
}());
export { DateEntryComponent };
